export default "__VITE_ASSET__CsvLQSUW__"